import React, { useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import OwnershipForm from '../../Property/Ownership/OwnershipForm';

export default function PropertyOwnershipPage({
	create_property_ownership_endpoint,
	get_property_ownership_by_property_endpoint,
	update_property_ownership_endpoint
}) {
	const { id } = useParams();

	const location = useLocation();
	const propertyName = location.state ? location.state.propertyName : '';
	const isEditing = location.state ? location.state.isEditing : '';

	useEffect(
		() => {
			// Log the propertyName to verify it's received correctly
			// console.log('Received propertyName:', propertyName);
		},
		[
			id,
			propertyName
		]
	);

	return (
		<div>
			<div className="-mt-8 md:-mt-12 mb-8 md:mb-12 md:text-xl">
				<Link to="/dashboard" className="hover:underline mr-2 md:mr-3">
					Dashboard
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
				<Link to={`/properties/${id}`} className="hover:underline mr-2 md:mr-3">
					{propertyName || 'Property Name'}
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
			</div>
			<OwnershipForm
				propertyId={id}
				propertyName={propertyName}
				isEditing={isEditing}
				create_property_ownership_endpoint={create_property_ownership_endpoint}
				get_property_ownership_by_property_endpoint={
					get_property_ownership_by_property_endpoint
				}
				update_property_ownership_endpoint={update_property_ownership_endpoint}
			/>
		</div>
	);
}

PropertyOwnershipPage.propTypes = {
	create_property_ownership_endpoint: PropTypes.string.isRequired,
	get_property_ownership_by_property_endpoint: PropTypes.string.isRequired,
	update_property_ownership_endpoint: PropTypes.string.isRequired
};
